export default __webpack_public_path__ + "static/media/header-bg.7c91eecb.png";